import Base from '@/gikam/js/components/base.js';
import Gikam from '../../../../core/gikam-core';
import Vue from 'vue';

const defaultOptions = {
    id: void 0,
    renderTo: void 0
}

export default class Les extends Base {

    constructor(props) {
        super();
        this.initialize(props, defaultOptions).init();
    }

    createModel() {
        const _this = this;
        this.model = new Vue({
            el: Gikam.createDom('div', this.options.renderTo),
            components: {
                les: () => import('@/gikam/js/components/huge/les/vue/main/les.vue')
            },
            data() {
                return { options: _this.options };
            },
            render(h) {
                return h('les');
            }
        });
    }

    /**
     *
     * 创建顶部区域按钮
     * @memberof Les
     */
    createTopButton() {
        const window = Gikam.getInstance(document.querySelector('.window'));
        Gikam.create('btnToolbar', {
            renderTo: window ? window.model.$refs.vm.$refs.topToolbar : this.options.renderTo,
            items: [{
                type: 'button',
                text: '添加内容',
                icon: 'add',
                onClick: this.addContent
            }, {
                type: 'button',
                text: '打印',
                icon: 'print',
                color: 'warning'
            }, {
                type: 'button',
                text: '审计跟踪',
                icon: 'view-audit',
                color: 'info'
            }, {
                type: 'button',
                text: '返回',
                icon: 'back',
                color: 'danger'
            }]
        });
    }

    /**
     *
     * 顶部添加内容按钮
     * @memberof Les
     */
    addContent() {
        this.addContentModal = new Vue({
            el: Gikam.createDom('div', document.body),
            components: {
                addContent: () => import('../vue/templates/addContent.vue')
            },
            render() {
                return <addContent />
            }
        })
    }

    init() {
        this.createModel();
        this.createTopButton();
    }
}